<template>
  <div class="flex">
    <TextButton v-for="i in opts" :key="i.type" :label="i.label" :click="i.click" :loading="i.loading"/>
  </div>
</template>
<script setup lang="tsx" name="SmartButtonList">
import TextButton from './components/test-button.vue'
import { computed, type PropType } from 'vue'
const props = defineProps({
  options: {
    type: Array as PropType<Record<any, any>[]>,
    default: () => []
  }
})

const opts = computed(() => props.options.filter((i) => i.display))
</script>
